import { createSlice } from "@reduxjs/toolkit";

export const confirmModalSlice = createSlice({
    name:"confirmModal",
    initialState: {
        show:false,
        onConfirm:null,
        onCancel:null,
        title:"",
        body:"",
    },
    reducers:{

        setShow:(state) => {
            state.show = !state.show;
        },

        setOnConfirm: (state,action) => {
            state.onConfirm = action.payload;
        },

        setOnCancel: (state,action) => {
            state.onCancel = action.payload;
        },

        setTitle: (state,action) => {
            state.title = action.payload;
        },

        setBody: (state,action) => {
            state.body = action.payload;
        },

        resetConfirmModal: (state)=> {
            state.show = false;
            state.onConfirm = null;
            state.onCancel = null;
            state.title = "";
            state.body = "";
        },
    }
});

export const { resetConfirmModal,setBody,setOnCancel,setOnConfirm,setShow,setTitle } = confirmModalSlice.actions;

export default confirmModalSlice.reducer;